/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import { useSubscription } from '@apollo/client' // Npm: Apollo client for handling graphql request.
import { useDispatch } from 'react-redux' // Npm: Redux dispatch hook.
import _ from 'underscore' // Npm: Underscore utility library.


/*
 * GRAPHS
 */
import RemoteSystemInformationReadSubscription from './__subscription__/remote.systemInformation.read.subscription'
import LocalSystemInformationReadSubscription from './__subscription__/local.systemInformation.read.subscription'


/*
 *  Handles Remote System Subscription (DB Server)
 */
const RemoteSystemSubscriptionHandler = () => {
  // Hook assignment.
  const dispatch = useDispatch()

  // Event handler - Subscription for remote system data.
  useSubscription(RemoteSystemInformationReadSubscription, {
    'onData': ({ data, error }) => {
      // If subscription caught an exception then report failure.
      if (error instanceof Error) {

        return dispatch({
          'type': 'SYSTEMINFO_REMOTE_ERROR',
          'payload': error
        })
      }

      // Only update if data is available.
      if (!_.isEmpty(data?.data?.SystemInformationRemoteRead)) {
        return dispatch({
          'type': 'SYSTEMINFO_REMOTE_UPDATE',
          'payload': data.data.SystemInformationRemoteRead
        })
      }
    }
  })

  // Return null as this is just a handler.
  return null
}


/*
 *  Handles Local System Subscription (Node Server)
 */
const LocalSystemSubscriptionHandler = () => {
  // Hook assignment.
  const dispatch = useDispatch()

  // Event handler - Subscription for local system data.
  useSubscription(LocalSystemInformationReadSubscription, {
    'onData': ({ data, error }) => {
      // If subscription caught an exception then report failure.
      if (error instanceof Error) {
        console.error('Local System Subscription Error:', error)
        return dispatch({
          'type': 'SYSTEMINFO_LOCAL_ERROR',
          'payload': error
        })
      }


      // Only update if data is available.
      if (!_.isEmpty(data?.data?.SystemInformationReadData)) {
        return dispatch({
          'type': 'SYSTEMINFO_LOCAL_UPDATE',
          'payload': data.data.SystemInformationReadData
        })
      }
    }
  })

  // Return null as this is just a handler.
  return null
}


/*
 *  Wraps both subscription handlers
 */
const SystemInfoSubscriptionProvider = ({ children }) => {
  // Return component.
  return (
    <>
      <RemoteSystemSubscriptionHandler />
      <LocalSystemSubscriptionHandler />
      {children}
    </>
  )
}


/*
 * EXPORTS
 */
export default SystemInfoSubscriptionProvider
